<template>
  <div class="container-page container-page-rktv pb-0">
    <div class="registry-mpk">
      <p class="registry-mpk__title title-inner title-inner--md">Реестр поручений по МПК</p>
      <div class="registry-mpk__header-container">
        <div class="registry-mpk__header-btnsBlock">
          <ButtonComponent
            v-permission="permissions.create"
            @click="addCard"
            class="registry-mpk__header-btnsBlock-item"
          >
            Создать поручение</ButtonComponent
          >
          <ButtonComponent @click="showUploadData" class="registry-mpk__header-btnsBlock-item"
            >Загрузить поручения</ButtonComponent
          >
          <ButtonComponent @click="exportExcel" class="registry-mpk__header-btnsBlock-item"
            >Скачать реестр поручений</ButtonComponent
          >
          <ButtonComponent @click="showExportMonitoring" class="registry-mpk__header-btnsBlock-item"
            >Скачать мониторинг</ButtonComponent
          >
        </div>
      </div>

      <div class="registry-mpk__header-filter filter">
        <div class="filter__item registry-mpk__inputBlock">
          <p class="label-field">Страна</p>
          <!-- Используется [...countryList] для корректного отображения начального выбранного значения -->
          <SelectSingleComponentCheckbox
            v-model="filter.countryId"
            trackBy="text"
            valueProp="id"
            labelOptions="text"
            placeholder="Выберите страну"
            :options="[...countryList]"
            :style="{ height: '40px' }"
            :canClear="false"
          />
        </div>

        <div class="filter__item registry-mpk__inputBlock">
          <p class="label-field">Мероприятия МПК</p>
          <SelectSingleComponentCheckbox
            v-model="filter.mpkEventId"
            trackBy="text"
            valueProp="id"
            labelOptions="text"
            placeholder="Выберите мероприятия МПК"
            :options="mpkEventList"
            :style="{ height: '40px' }"
            :canClear="false"
            :disabled="isMpkEventsSelectDisabled"
          />
        </div>
      </div>

      <div class="registry-mpk__info-container">
        <InfoCountList :style="{ marginBottom: 0 }" :infoCountList="legend" />
      </div>

      <div
        class="registry-mpk__header-container-additional"
        :class="{ 'is-hidden': !selectedIds.length }"
        :aria-hidden="!selectedIds.length"
      >
        <span class="registry-mpk__additional-count">Выбрано: {{ selectedIds.length }}</span>
        <ButtonComponent
          v-if="canStartMultiple"
          mod="transparent-bg"
          class="registry-mpk__additional-item button-redesign--md"
          @click="showStartMultipleDialog"
          >На исполнение</ButtonComponent
        >
        <ButtonComponent
          mod="transparent-bg"
          class="registry-mpk__additional-item button-redesign--md"
          @click="showChangeControlDateDialog"
          >Сменить дату контроля</ButtonComponent
        >
      </div>
      <div class="mb-20">
        <DefaultFilter :filterValue="filter" @loadFilter="onLoadFilter" />
      </div>
    </div>
  </div>

  <AssignmentsTable
    v-model:selectedIds="selectedIds"
    v-model:filter="filter"
    :canEdit="canEdit"
    :canDelete="canDelete"
    :filterProps="filter"
    :page="page"
    :mpkEventList="mpkEventList"
    :organizationList="organizationList"
    :statusList="statusList"
    :isLoading="isLoading"
    :isLoadingMore="isLoadingMore"
    @changeSorting="changeSorting"
    @editCard="editCard"
    @deleteCard="deleteCard"
    @onPageChange="onPageChange"
    @filterChanged="onFilterChanged"
  />
  <div class="container-page container-page-rktv">
    <div class="registry-mpk">
      <ModalComponent
        title="Форма создания поручения"
        contentClass="modal--new"
        themeLigth
        @close="closeDialogState"
        v-model="dialogState"
      >
        <AssignmentCardAdd
          :key="dialogNn"
          :nn="dialogNn"
          :id="dialogId"
          :countryList="countryList.slice(1)"
          @save="afterSaveCard"
          @close="dialogState = false"
        />
      </ModalComponent>

      <ModalComponent
        title="Выгрузить отчет"
        contentClass="modal--new"
        themeLigth
        @close="dialogWordState = false"
        v-model="dialogWordState"
      >
        <div class="form__body form__body--redesigned">
          <div>
            <div class="form__body-inputBlock mb-3 pb-3">
              <p>Мероприятие</p>
              <SelectSingleComponentCheckbox
                :style="{ height: '40px' }"
                v-model="dialogWordEventId"
                placeholder="Укажите мероприятие"
                trackBy="text"
                valueProp="id"
                labelOptions="text"
                :options="mpkEventList"
                :canClear="false"
                required
              />
            </div>
            <div class="form__body-inputBlock mb-3 pb-3">
              <p>Укажите формат</p>
              <SelectSingleComponentCheckbox
                :style="{ height: '40px' }"
                v-model="dialogWordFileTypeId"
                placeholder="Укажите формат"
                trackBy="text"
                valueProp="id"
                labelOptions="text"
                :options="fileTypeList"
                :canClear="false"
                required
              />
            </div>
          </div>
          <div class="form__body-inputBlock mb-0">
            <ButtonComponent mod="gradient-bg" @click="exportFile">Выгрузить</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent
        title="Скачать мониторинг"
        contentClass="modal--new"
        width="632"
        themeLigth
        @close="handleMonitoringModalClose"
        v-model="dialogMonitoringWordState"
      >
        <div class="form__body form__body--redesigned">
          <div class="form__body-inputBlock mb-3 pb-3">
            <p>Страна</p>
            <SelectSingleComponentCheckbox
              :style="{ height: '40px' }"
              v-model="dialogMonitoringWordCountryId"
              placeholder="Укажите страну"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              :options="countryListForMonitoringModal"
              :canClear="true"
            />
          </div>
          <div class="form__body-inputBlock mb-3 pb-3">
            <p>Мероприятие</p>
            <SelectSingleComponentCheckbox
              :style="{ height: '40px' }"
              v-model="dialogMonitoringWordEventId"
              placeholder="Укажите мероприятие"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              :options="mpkEventByCountryList"
              :canClear="false"
              :disabled="isMonitoringModalEventSelectDisabled"
            />
          </div>
          <div class="form__body-inputBlock mb-3 pb-3">
            <p>Укажите формат</p>
            <SelectSingleComponentCheckbox
              :style="{ height: '40px' }"
              v-model="dialogMonitoringWordFileTypeId"
              placeholder="Укажите формат"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              :options="fileTypeList"
              :canClear="false"
              required
            />
          </div>
          <div class="form__body-inputBlock">
            <ButtonComponent mod="gradient-bg" @click="exportFileMonitoring">Скачать</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent
        v-model="importModal"
        title="Импорт файла"
        contentClass="modal--new"
        themeLigth
        @close="closeImportModal"
      >
        <p v-if="templatePreparing">Подготовка шаблона</p>
        <a href="javascript:" @click="getUploadTemplate" v-if="!templatePreparing">Скачать шаблон</a>
        <div class="my-2">
          <label class="form-label" for="assignment-import-status">Статус для новых поручений</label>
          <SelectSingleComponentCheckbox
            id="assignment-import-status"
            :style="{ height: '40px' }"
            v-model="importStatusId"
            placeholder="Статус для новых поручений"
            trackBy="text"
            valueProp="id"
            labelOptions="text"
            :options="importStatusList"
            :canClear="false"
            required
            :error="v$.importStatusId.$error"
          />
          <div class="invalid-msg mt-1" v-if="v$.importStatusId.$error">Поле обязательно для заполнения</div>
        </div>
        <ImportModalRedesigned v-if="importModal" @doimport="doImport" @close="closeImportModal" />
      </ModalComponent>

      <ModalComponent
        title="На исполнение"
        contentClass="modal--new"
        themeLigth
        @close="startMultipleModal = false"
        v-model="startMultipleModal"
      >
        <div class="registry-mpk__form-body">
          <div class="registry-mpk__form-body-inputBlock textarea">
            <p>Комментарии</p>
            <ComponentInput
              v-model="startMultipleRazdelProtocal"
              type="textarea"
              mod="redesigned"
              placeholder="Добавьте комментарий при необходимости"
              :textareaStyles="{ 'min-height': '140px' }"
            />
          </div>
          <div class="registry-mpk__form-body-button-container">
            <ButtonComponent mod="gradient-bg" class="registry-mpk__form-body-button" @click="doStartMultiple"
              >Подтвердить</ButtonComponent
            >
            <ButtonComponent class="registry-mpk__form-body-button" @click="startMultipleModal = false">
              Закрыть</ButtonComponent
            >
          </div>
        </div>
      </ModalComponent>

      <ModalComponent
        title="Сменить срок контроля"
        contentClass="modal--new"
        themeLigth
        @close="dateChangeModal = false"
        v-model="dateChangeModal"
      >
        <div class="registry-mpk__form-body">
          <div class="registry-mpk__form-body-inputBlock required">
            <label class="form-label" for="assignment-change-date">Новый срок контроля</label>
            <div class="modal-date-container">
              <DateComponent
                id="assignment-change-date"
                v-model="dateChangeDate"
                :clearable="false"
                modClass="redesigned"
                dateIcon
                required
              />
            </div>
          </div>
          <div class="registry-mpk__form-body-button-container">
            <ButtonComponent mod="gradient-bg" class="registry-mpk__form-body-button" @click="doChangeDate">
              Подтвердить
            </ButtonComponent>
            <ButtonComponent class="registry-mpk__form-body-button" @click="dateChangeModal = false">
              Закрыть
            </ButtonComponent>
          </div>
        </div>
      </ModalComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';
  import { debounce } from 'lodash';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DateComponent from '@/common/components/DateComponent/DateComponent.vue';
  import DefaultFilter from '@/common/components/DefaultFilter.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import ImportModalRedesigned from '@/common/components/redesigned/ImportModalRedesigned.vue';
  import SelectSingleComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectSingleComponentCheckbox.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import Utils from '@/common/utils';
  import { loadFilter, saveFilter } from '@/common/utils/filterManager';

  import InfoCountList from '@/components/InfoCountList.vue';
  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import API from '../api/assignment';
  import AssignmentCardAdd from '../components/assigments/AssignmentCardAdd.vue';
  import AssignmentsTable from '../components/assigments/AssignmentsTable.vue';
  import { MPK_ROLE_ID } from '../utils/constants';

  import parseParamId from '@/utils/parseParamId';

  const PERMISSIONS = {
    view: Constants.Permissions.MpkAssignmentAccess,
    create: Constants.Permissions.MpkAssignmentCreate,
    edit: Constants.Permissions.MpkAssignmentEdit,
    delete: Constants.Permissions.MpkAssignmentDelete,
  };

  export default {
    name: 'Assignments',
    components: {
      ModalComponent,
      AssignmentCardAdd,
      ComponentInput,
      DefaultFilter,
      DateComponent,
      InfoCountList,
      ImportModalRedesigned,
      SelectSingleComponentCheckbox,
      AssignmentsTable,
      ButtonComponent,
    },
    mixins: [security],
    data() {
      return {
        request: {
          pageNumber: 1,
          pageSize: Constants.pageSize,
        },
        filter: {
          countryId: this.$route.query?.countryId ?? null,
          mpkEventId: this.$route.query?.mpkEventId ?? null,
          brief: '',
          srokFrom: null,
          srokTo: null,
          organizationId: null,
          mpkRegistryStatusId: null,
          report: '',
          razdelProtocal: '',
          noPoint: '',
          deadlineFrom: null,
          deadlineTo: null,
          periodicity: null,

          // Сортировка столбцов
          // 0 - название заседания
          // 1 - № поручения
          // 2 - № п/п
          // 3 - поручение
          // 4 - срок исполнения
          // 5 - исполнитель
          // 6 - статус
          // 7 - срок отчета в Минэкономразвития России
          // 8 - периодичность отчета
          sortColumn: 0,
          sortOrder: 0,
        },
        page: {},
        totalData: {},
        canEdit: false,
        canDelete: false,
        isLoading: false,
        isLoadingMore: false,

        statusList: [],
        organizationList: [],
        countryList: [{ id: '0', text: 'Все', selected: true }],
        fileTypeList: [
          { id: 1, text: 'Документ Microsoft Word (DOCX)', selected: true },
          { id: 2, text: 'Документ PDF' },
        ],
        importStatusList: [
          { id: 1, text: 'Проект поручения', selected: true },
          { id: 2, text: 'Новое' },
        ],
        importStatusId: null,
        mpkEventList: [],
        mpkEventByCountryList: [],

        dialogState: false,
        dialogNn: 1,
        dialogId: 0,

        dialogMonitoringWordState: false,
        dialogMonitoringModalSkipCountryWatch: false,
        dialogMonitoringWordCountryId: null,
        dialogMonitoringWordEventId: null,
        dialogMonitoringWordFileTypeId: 1,
        dialogWordState: false,
        dialogWordEventId: 0,
        dialogWordFileTypeId: 1,
        templatePreparing: false,
        importModal: false,
        selectedIds: [],
        selectAll: false,
        startMultipleModal: false,
        startMultipleRazdelProtocal: null,
        dateChangeModal: false,
        dateChangeDate: null,
        legend: [],
        comment: null,
      };
    },
    async created() {
      this.debouncedChangeFilter = debounce(this.changeFilter, 300);
      this.isLoading = true;

      const isAllowed = await this.checkPermissionAndRedirect(PERMISSIONS.view);
      if (!isAllowed) return;

      this.checkPermission(PERMISSIONS.edit).then((response) => {
        this.canEdit = response.data;
      });
      this.checkPermission(PERMISSIONS.delete).then((response) => {
        this.canDelete = response.data;
      });

      this.loadStatusList();
      this.loadOrganizations();
      this.loadMpkEvent();

      loadFilter(this.$options.name).then((response) => {
        if (response) {
          const filter = response;
          let countryId = this.filter.countryId;
          let mpkEventId = this.filter.mpkEventId;

          if (countryId !== null) {
            filter.countryId = countryId;
          }

          if (mpkEventId !== null) {
            filter.mpkEventId = mpkEventId;
          }

          this.filter = filter;
        }

        this.loadGroupData();
        this.loadPage(false);
        this.loadCountryListForAssignments();
      });
    },
    computed: {
      permissions() {
        return PERMISSIONS;
      },
      canStartMultiple() {
        let profile = this.$store.state.auth?.oidc?.profile;
        if (profile == null) profile = JSON.parse(localStorage.getItem('userProfileData'));
        const roleIds = profile?.roleIds;
        return roleIds.includes(MPK_ROLE_ID.ADMIN) || roleIds.includes(MPK_ROLE_ID.SECRETARY_MPK);
      },
      countryListForMonitoringModal() {
        return this.countryList
          .filter((countryItem) => countryItem.id > 0)
          .slice()
          .sort((firstCountry, secondCountry) =>
            String(firstCountry.text).localeCompare(String(secondCountry.text), 'ru'),
          );
      },
      isMonitoringModalEventSelectDisabled() {
        const countryId = parseParamId(this.dialogMonitoringWordCountryId);
        return !countryId || this.mpkEventByCountryList.length === 0;
      },
      isMpkEventsSelectDisabled() {
        return Number(this.filter?.countryId) <= 0 || this.mpkEventList.length === 0;
      },
    },
    methods: {
      loadCountryListForAssignments() {
        Utils.searchNsi('countryList').then((response) => {
          while (this.countryList.length > 1) {
            this.countryList.pop();
          }

          if (response.data?.length) {
            const sortedCountryItems = [...response.data].sort((firstCountry, secondCountry) =>
              String(firstCountry.text).localeCompare(String(secondCountry.text), 'ru'),
            );

            sortedCountryItems.forEach((countryItem) =>
              this.countryList.push({
                ...countryItem,
                id: String(countryItem.id),
              }),
            );
          }
        });
      },

      handleMonitoringModalClose() {
        this.dialogMonitoringModalSkipCountryWatch = false;
        this.dialogMonitoringWordState = false;
      },

      resolveMpkEventSortTimestamp(mpkEventItem) {
        const rawDate =
          mpkEventItem.eventDate?.date ?? mpkEventItem.event_date?.date ?? mpkEventItem.eventDate ?? mpkEventItem.date;
        const parsedTimestamp = rawDate ? new Date(rawDate).getTime() : Number.NaN;

        if (!Number.isNaN(parsedTimestamp)) {
          return parsedTimestamp;
        }

        if (mpkEventItem.selected) {
          return Number.MAX_SAFE_INTEGER;
        }

        return 0;
      },

      getDefaultMpkEventIdByLastEventDate(mpkEventsList) {
        if (!mpkEventsList.length) {
          return null;
        }

        const eventsOrderedByDate = mpkEventsList
          .map((mpkEventItem) => ({
            mpkEventItem,
            sortTimestamp: this.resolveMpkEventSortTimestamp(mpkEventItem),
          }))
          .sort((first, second) => second.sortTimestamp - first.sortTimestamp);

        return eventsOrderedByDate[0]?.mpkEventItem?.id ?? null;
      },

      syncMonitoringModalEventFromFilters(pageEventId) {
        const normalizedEventId = pageEventId == null ? NaN : Number(pageEventId);

        if (!Number.isNaN(normalizedEventId) && normalizedEventId !== 0) {
          const matchedEvent = this.mpkEventByCountryList.find(
            (mpkEventItem) => Number(mpkEventItem.id) === normalizedEventId,
          );

          if (matchedEvent) {
            this.dialogMonitoringWordEventId = matchedEvent.id;
            return;
          }
        }

        this.dialogMonitoringWordEventId = this.getDefaultMpkEventIdByLastEventDate(this.mpkEventByCountryList);
      },

      loadMpkEvent(params = {}) {
        const countryId = parseParamId(this.filter.countryId);
        const newParams = {
          countryId,
          ...params,
        };
        API.getEventForList(newParams).then((response) => {
          const rawList = response.data ?? [];
          this.mpkEventList = rawList.map((eventItem) => ({
            ...eventItem,
            id: String(eventItem.id),
          }));
        });
      },
      loadStatusList() {
        API.getMpkRegistryAssignmentStatusList().then((response) => {
          if (response.data && response.data.length) {
            this.statusList = response.data;
          }
        });
      },
      loadOrganizations() {
        const params = { ...this.filter, ...Constants.paramsFullListDefault };
        API.orgList(params).then((response) => {
          this.organizationList = [];
          if (response.data && response.data.items.length) {
            response.data.items.forEach((i) => this.organizationList.push({ id: i.id, text: i.name }));
          }
        });
      },
      addCard() {
        this.dialogState = true;
        this.dialogNn++;
        this.dialogId = 0;
      },
      editCard(id) {
        this.dialogState = true;
        this.dialogNn++;
        this.dialogId = id;
      },
      closeDialogState() {
        this.dialogState = false;
        this.dialogId = 0;
      },
      deleteCard(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            API.deleteExecutor(id)
              .then(() => {
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadGroupData();
                this.loadPage();
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data ? error.response.data : 'Запись не удалена',
                  'error',
                );
              });
          }
        });
      },
      afterSaveCard() {
        this.closeDialogState();
        this.loadGroupData();
        this.loadPage(false);
      },

      changeFilter() {
        this.request.pageNumber = 1;
        saveFilter(this.$options.name, this.filter);
        this.loadPage(false);
      },
      onPageChange(pageNumber, addToExist) {
        this.request.pageNumber = pageNumber;
        this.loadPage(addToExist);
      },
      loadGroupData() {
        API.getTotal({ countryId: this.filter.countryId, mpkEventId: this.filter.mpkEventId }).then((response) => {
          this.totalData = response.data;
          this.legend = [
            { title: 'Всего поручений', count: this.totalData.totalCount },
            { title: 'Не выполнено', count: this.totalData.notExecute ?? 0 },
            { title: 'В работе', count: this.totalData.inWork ?? 0 },
            { title: 'Выполнено', count: this.totalData.done ?? 0 },
          ];
        });
      },
      loadPage(addToExist) {
        addToExist ? (this.isLoadingMore = true) : (this.isLoading = true);
        const params = { ...this.filter, ...this.request };

        Promise.all([API.search(params), this.loadOrganizations()])
          .then(([searchResponse]) => {
            // Обрабатываем результаты поиска
            if (!addToExist) {
              this.page = {};
              this.$nextTick(() => {
                this.page = searchResponse.data;
              });
            } else if (searchResponse.data) {
              this.page.pageNumber = searchResponse.data.pageNumber;
              this.page.items = this.page.items.concat(searchResponse.data.items);
            }
          })
          .finally(() => {
            this.isLoading = false;
            this.isLoadingMore = false;
          });
      },
      exportExcel() {
        const params = Object.assign(this.filter, this.request);
        API.exportExcel(params);
      },

      exportFile() {
        if (this.dialogWordEventId !== null && this.dialogWordFileTypeId) {
          API.exportFile({
            mpkEventId: this.dialogWordEventId,
            fileTypeId: this.dialogWordFileTypeId,
          });
          this.dialogWordEventId = null;
          this.dialogWordFileTypeId = 1;
          this.dialogWordState = false;
        } else {
          Constants.alert.fire('Отчет', 'Выберите мероприятие и тип файла', 'error');
          this.dialogWordEventId = null;
          this.dialogWordFileTypeId = 1;
        }
      },

      showExportMonitoring() {
        this.dialogMonitoringModalSkipCountryWatch = true;
        this.dialogMonitoringWordFileTypeId = 1;
        this.dialogMonitoringWordCountryId = null;
        this.dialogMonitoringWordEventId = null;
        this.mpkEventByCountryList = [];
        this.dialogMonitoringWordState = true;

        const pageCountryId = parseParamId(this.filter.countryId);
        const pageEventId = parseParamId(this.filter.mpkEventId);

        if (!pageCountryId) {
          this.dialogMonitoringModalSkipCountryWatch = false;
          return;
        }

        this.dialogMonitoringWordCountryId = pageCountryId;

        API.getEventForList({ countryId: pageCountryId })
          .then((response) => {
            if (parseParamId(this.dialogMonitoringWordCountryId) !== pageCountryId) {
              return;
            }
            this.mpkEventByCountryList = response.data ?? [];
            this.syncMonitoringModalEventFromFilters(pageEventId);
          })
          .finally(() => {
            this.dialogMonitoringModalSkipCountryWatch = false;
          });
      },
      exportFileMonitoring() {
        const countryId = parseParamId(this.dialogMonitoringWordCountryId);
        const eventId = parseParamId(this.dialogMonitoringWordEventId);
        if (countryId && eventId && this.dialogMonitoringWordFileTypeId) {
          API.exportFileMonitoring({
            mpkEventId: eventId,
            fileTypeId: this.dialogMonitoringWordFileTypeId,
          });
          this.handleMonitoringModalClose();
        } else {
          Constants.alert.fire('Отчет о мониторинге', 'Выберите страну и мероприятие', 'error');
        }
      },
      changeSorting(id) {
        if (this.filter.sortColumn == id) this.filter.sortOrder = this.filter.sortOrder == 0 ? 1 : 0;
        else this.filter.sortOrder = 0;
        this.filter.sortColumn = id;
        this.loadPage(false);
      },
      showUploadData() {
        this.importModal = true;
      },
      getUploadTemplate() {
        this.templatePreparing = true;
        API.getUploadTemplate().then(() => {
          this.templatePreparing = false;
        });
      },
      doImport(file) {
        this.v$.importStatusId.$touch();
        if (this.v$.importStatusId.$invalid) {
          return;
        }
        API.uploadFile(file, this.importStatusId)
          .then((response) => {
            if (response.data.success)
              Constants.alert.fire(
                'Импорт',
                'Импорт успешно выполнен. Добавлено записей: ' + response.data.addedCount,
                'success',
              );
            else {
              Constants.alert.fire({
                title: 'Импорт',
                icon: 'error',
                html:
                  'Ошибок при импорте данных: ' +
                  response.data.errors.length +
                  '. <a href="javascript:" class="import-alert-link">Скачать отчет</a>.',
              });
              const elements = document.getElementsByTagName('a');
              for (var i = 0; i < elements.length; i++) {
                if (elements[i].className == 'import-alert-link') {
                  elements[i].onclick = function () {
                    let txtContent = 'data:text/txt;charset=utf-8,' + response.data.errors.join('\n');
                    const encodedUri = encodeURI(txtContent);
                    const link = document.createElement('a');
                    link.setAttribute('href', encodedUri);
                    link.setAttribute('download', 'Отчет об ошибках.txt');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  };
                }
              }
            }
            this.loadPage();
          })
          .catch(() => {
            Constants.alert.fire('Импорт', 'Ошибка при импорте данных.', 'error');
          });
        this.closeImportModal();
      },
      closeImportModal() {
        this.importModal = false;
        this.importStatusId = null;
        this.v$.importStatusId.$reset();
      },
      onLoadFilter(item) {
        this.filter = item;
        this.changeFilter();
      },
      clearSelection() {
        this.selectedIds = [];
      },
      showStartMultipleDialog() {
        if (this.selectedIds && this.selectedIds.length) {
          this.v$.$reset();
          this.comment = null;
          this.startMultipleModal = false;
          this.startMultipleModal = true;
        }
      },
      doStartMultiple() {
        const assignmentIds = [
          ...new Set(this.page.items.filter((x) => this.selectedIds.includes(x.id)).map((x) => x.assignmentId)),
        ];

        const itemToSave = {
          Ids: assignmentIds,
          comment: this.comment,
        };

        API.startMultiple(itemToSave)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadPage();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          })
          .finally(() => {
            this.startMultipleModal = false;
            this.selectAll = false;
            this.clearSelection();
          });
      },
      showChangeControlDateDialog() {
        if (this.selectedIds && this.selectedIds.length) {
          this.v$.$reset();
          this.dateChangeDate = null;
          this.dateChangeModal = false;
          this.dateChangeModal = true;
        }
      },
      doChangeDate() {
        this.v$.$touch();
        if (this.v$.dateChangeDate.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        const itemToSave = {
          ids: this.selectedIds,
          date: this.dateChangeDate,
        };

        API.changeDate(itemToSave)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadPage();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          })
          .finally(() => {
            this.dateChangeModal = false;
            this.selectAll = false;
            this.clearSelection();
          });
      },
      onFilterChanged(newFilter) {
        this.filter = newFilter;
        this.debouncedChangeFilter();
      },
    },
    watch: {
      selectAll: function (value) {
        if (value) {
          this.selectedIds = [];
          this.selectedIds.push(...this.page.items.map((x) => x.id));
        } else {
          this.clearSelection();
        }
      },
      'filter.countryId'(newValue, oldValue) {
        if (newValue !== oldValue) {
          const countryId = parseParamId(newValue);
          this.filter.mpkEventId = 0;

          this.loadMpkEvent();
          this.loadGroupData();
          this.changeFilter();
          this.$router.replace({
            query: countryId ? { countryId } : null,
          });
        }
      },
      mpkEventList: {
        handler(newList) {
          const defaultOption = newList.find((item) => item.selected);

          if (Number(this.filter.countryId) && defaultOption) {
            this.filter.mpkEventId = defaultOption.id;
          }
        },
        deep: true,
      },
      'filter.mpkEventId'(newValue) {
        const countryId = parseParamId(this.filter.countryId);
        const mpkEventId = parseParamId(newValue);

        this.loadGroupData();
        this.changeFilter();
        this.$router.replace({
          query: {
            countryId,
            mpkEventId,
          },
        });
      },
      dialogMonitoringWordCountryId(newValue, oldValue) {
        if (!this.dialogMonitoringWordState || this.dialogMonitoringModalSkipCountryWatch) {
          return;
        }

        const newCountryId = parseParamId(newValue);
        const oldCountryId = parseParamId(oldValue);

        if (newCountryId === oldCountryId) {
          return;
        }

        if (!newCountryId) {
          this.mpkEventByCountryList = [];
          this.dialogMonitoringWordEventId = null;
          return;
        }

        API.getEventForList({ countryId: newCountryId }).then((response) => {
          if (parseParamId(this.dialogMonitoringWordCountryId) !== newCountryId) {
            return;
          }
          this.mpkEventByCountryList = response.data ?? [];
          this.dialogMonitoringWordEventId = this.getDefaultMpkEventIdByLastEventDate(this.mpkEventByCountryList);
        });
      },
    },
    beforeUnmount() {
      if (this.debouncedChangeFilter) {
        this.debouncedChangeFilter.cancel();
      }
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        dateChangeDate: { required },
        importStatusId: { required },
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/theme/default/table/table-base.scss';
  @import '../styles/Assignments.scss';
</style>
